import { render } from "./ColumnUi.vue?vue&type=template&id=ec3d3456&scoped=true"
import script from "./ColumnUi.vue?vue&type=script&lang=js"
export * from "./ColumnUi.vue?vue&type=script&lang=js"

import "./ColumnUi.vue?vue&type=style&index=0&id=ec3d3456&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cts-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec3d3456"]])

export default __exports__